<template>
  <form class="quick-category" @submit.prevent="onSubmit">
    <div class="quick-category__grid">
      <div class="quick-category__field">
        <label>نام دسته</label>
        <input v-model="form.name" type="text" class="form-control" placeholder="نام دسته" @input="syncSlug">
      </div>
      <div class="quick-category__field">
        <label>slug</label>
        <input v-model="form.slug" type="text" class="form-control" placeholder="slug">
      </div>
      <div class="quick-category__field">
        <label>زبان</label>
        <select class="form-control custom-select" v-model="form.language_id">
          <option value="">انتخاب زبان</option>
          <option v-for="language in languages" :key="language.id" :value="language.id">
            {{ language.name }}
          </option>
        </select>
      </div>
      <div class="quick-category__field">
        <label>ترتیب</label>
        <input v-model="form.order" type="number" min="1" class="form-control" placeholder="ترتیب">
      </div>

      <div class="quick-category__field quick-category__field--full">
        <label>دسته والد (برای زیردسته)</label>

        <div class="quick-category__parent-selected" v-if="selectedParent">
          <button type="button" class="quick-category__parent-chip" @click="clearParent">
            {{ selectedParent.name }}
            <span aria-hidden="true">×</span>
          </button>
          <span class="quick-category__parent-hint">برای حذف والد روی آن کلیک کنید</span>
        </div>
        <p class="quick-category__parent-empty" v-else>بدون والد (دسته اصلی)</p>

        <div class="quick-category__parent-box">
          <div class="quick-category__parent-search">
            <input
                v-model="parentSearch"
                type="text"
                class="form-control"
                placeholder="جستجوی دسته والد...">
            <button
                type="button"
                class="quick-category__parent-refresh"
                title="بروزرسانی"
                @click="refreshCategories">
              <b-icon icon="arrow-clockwise"/>
            </button>
          </div>

          <div class="quick-category__parent-list">
            <button
                type="button"
                class="quick-category__parent-item"
                :class="{ 'is-active': form.parent_id === item.id }"
                v-for="item in filteredParentOptions"
                :key="item.id"
                @click="selectParent(item)">
              <span class="quick-category__parent-dot" aria-hidden="true"></span>
              <span class="quick-category__parent-name">{{ item.label }}</span>
            </button>
            <p class="quick-category__parent-none" v-if="!filteredParentOptions.length">
              نتیجه‌ای پیدا نشد
            </p>
          </div>
        </div>
      </div>

      <div class="quick-category__field quick-category__field--full">
        <label>تصویر دسته</label>
        <div class="quick-category__image">
          <input
              id="quick-category-image"
              type="file"
              accept="image/*"
              class="d-none"
              @change="onImageChange">
          <label for="quick-category-image" class="quick-category__image-picker">
            <img v-if="form.preview" :src="form.preview" alt="" class="quick-category__image-preview">
            <template v-else>
              <b-icon icon="image" class="quick-category__image-icon"/>
              <span>انتخاب تصویر</span>
            </template>
          </label>
          <button
              v-if="form.preview"
              type="button"
              class="quick-category__image-remove"
              @click="clearImage">
            حذف تصویر
          </button>
        </div>
      </div>
    </div>

    <div class="quick-category__field">
      <label>توضیحات</label>
      <textarea v-model="form.description" class="form-control" rows="3" placeholder="توضیحات (اختیاری)"></textarea>
    </div>

    <div class="quick-category__actions">
      <button type="submit" class="quick-category__submit" :disabled="loading">
        {{ loading ? 'در حال ثبت...' : 'ثبت دسته' }}
      </button>
    </div>
  </form>
</template>

<script>
import {mapGetters} from 'vuex'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";

export default {
  name: "QuickCategoryCreate",
  data() {
    return {
      loading: false,
      parentSearch: '',
      form: {
        name: '',
        slug: '',
        description: '',
        image: [],
        parent_id: '',
        parent: {},
        status: 1,
        order: 1,
        language_id: '',
        preview: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages",
      categories: "Category/getCategories",
    }),
    parentOptions() {
      const walk = (items, depth = 0) => {
        let rows = []
        ;(items || []).forEach(item => {
          rows.push({
            id: item.id,
            name: item.name,
            label: `${'— '.repeat(depth)}${item.name}`,
          })
          if (item.children && item.children.length) {
            rows = rows.concat(walk(item.children, depth + 1))
          }
        })
        return rows
      }
      return walk(this.categories)
    },
    filteredParentOptions() {
      const q = (this.parentSearch || '').trim()
      if (!q) {
        return this.parentOptions
      }
      return flatCategories(this.categories || [])
          .filter(item => (item.name || '').indexOf(q) > -1)
          .map(item => ({
            id: item.id,
            name: item.name,
            label: item.name,
          }))
    },
    selectedParent() {
      if (!this.form.parent_id) {
        return null
      }
      return this.parentOptions.find(item => item.id === this.form.parent_id) || null
    },
  },
  methods: {
    syncSlug() {
      if (!this.form.name) {
        this.form.slug = ''
        return
      }
      let link = this.form.name.toLowerCase()
      link = link.replace(/ +/g, "-")
      link = link.replace(/[^\wآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+/g, "-")
      this.form.slug = link
    },
    refreshCategories() {
      this.$store.dispatch('Category/getDashboardCategories')
    },
    selectParent(item) {
      if (this.form.parent_id === item.id) {
        this.clearParent()
        return
      }
      this.form.parent_id = item.id
      this.form.parent = item
      toast('والد انتخاب شد', item.name)
    },
    clearParent() {
      this.form.parent_id = ''
      this.form.parent = {}
    },
    onImageChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) {
        return
      }
      this.form.image = file
      this.form.preview = URL.createObjectURL(file)
    },
    clearImage() {
      this.form.image = []
      this.form.preview = ''
      const input = document.getElementById('quick-category-image')
      if (input) {
        input.value = ''
      }
    },
    async onSubmit() {
      if (!this.form.name || !this.form.slug || !this.form.language_id) {
        toast('خطا', 'نام، slug و زبان الزامی است.')
        return
      }
      this.loading = true
      try {
        const payload = {
          ...this.form,
          parent_id: this.form.parent_id || null,
        }
        await this.$store.dispatch('Category/createCategory', payload)
        await this.$store.dispatch('Category/getDashboardCategories')
        this.$emit('created')
        this.form.name = ''
        this.form.slug = ''
        this.form.description = ''
        this.clearParent()
        this.form.order = 1
        this.parentSearch = ''
        this.clearImage()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    const defaultLanguage = findAttributeOnSiteInfo('default_language')
    if (defaultLanguage && defaultLanguage[0]) {
      this.form.language_id = defaultLanguage[0].id
    }
    if (!(this.categories && this.categories.length)) {
      this.$store.dispatch('Category/getDashboardCategories')
    }
  }
}
</script>

<style scoped>
.quick-category {
  display: grid;
  gap: 1rem;
}

.quick-category__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
}

.quick-category__field--full {
  grid-column: 1 / -1;
}

.quick-category__field > label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 700;
  color: #424242;
}

.quick-category__field .form-control,
.quick-category__field .custom-select {
  border-radius: 12px;
}

.quick-category__parent-selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 0.65rem;
}

.quick-category__parent-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: 0;
  border-radius: 999px;
  background: rgba(235, 61, 96, 0.12);
  color: #eb3d60;
  font-weight: 700;
  padding: 0.35rem 0.75rem;
  cursor: pointer;
}

.quick-category__parent-hint,
.quick-category__parent-empty {
  margin: 0 0 0.65rem;
  color: #6b6b6b;
  font-size: 0.82rem;
}

.quick-category__parent-box {
  border: 1px solid rgba(30, 30, 30, 0.08);
  border-radius: 14px;
  background: #f7f7f8;
  overflow: hidden;
}

.quick-category__parent-search {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.7rem;
  background: #ececed;
  border-bottom: 1px solid rgba(30, 30, 30, 0.08);
  position: sticky;
  top: 0;
  z-index: 1;
}

.quick-category__parent-search .form-control {
  flex: 1 1 auto;
  min-width: 0;
}

.quick-category__parent-refresh {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(30, 30, 30, 0.1);
  border-radius: 12px;
  background: #fff;
  color: #424242;
  flex: 0 0 auto;
  cursor: pointer;
}

.quick-category__parent-refresh:hover {
  border-color: #eb3d60;
  color: #eb3d60;
}

.quick-category__parent-list {
  height: 240px;
  overflow-y: auto;
  padding: 0.45rem;
}

.quick-category__parent-item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #424242;
  text-align: right;
  cursor: pointer;
}

.quick-category__parent-item:hover,
.quick-category__parent-item.is-active {
  background: rgba(235, 61, 96, 0.1);
  color: #eb3d60;
}

.quick-category__parent-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #eb3d60;
  flex: 0 0 auto;
}

.quick-category__parent-name {
  font-weight: 600;
}

.quick-category__parent-none {
  margin: 1rem 0.5rem;
  color: #8a8a8a;
  text-align: center;
}

.quick-category__image {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.quick-category__image-picker {
  display: inline-flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 120px;
  height: 120px;
  margin: 0 !important;
  padding: 0;
  border: 1.5px dashed rgba(30, 30, 30, 0.18);
  border-radius: 16px;
  background: #f7f7f8;
  color: #6b6b6b;
  font-weight: 700;
  font-size: 0.8rem;
  line-height: 1.2;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.quick-category__image-picker:hover {
  border-color: #eb3d60;
  color: #eb3d60;
  background: rgba(235, 61, 96, 0.04);
}

.quick-category__image-icon {
  display: block;
  font-size: 1.75rem;
  line-height: 1;
}

.quick-category__image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.quick-category__image-remove {
  border: 0;
  border-radius: 999px;
  background: rgba(220, 37, 48, 0.1);
  color: #dc2530;
  font-weight: 700;
  padding: 0.45rem 0.9rem;
  cursor: pointer;
}

.quick-category__actions {
  display: flex;
  justify-content: flex-end;
}

.quick-category__submit {
  min-height: 44px;
  padding: 0 1.4rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}

.quick-category__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 767.98px) {
  .quick-category__grid {
    grid-template-columns: 1fr;
  }
}
</style>
